const i="353:1",t="magazineluiza.com.br",c="wishlist",o="client",a="product";export{i as ACCOUNT,t as DOMAIN,o as EVENT_CLIENT,a as EVENT_PRODUCT,c as EVENT_WISHLIST};
